import rootStore from 'stores/RootStore';

export default function(WrappedComponent) {
  return class extends WrappedComponent {
    appStore = rootStore.appStore;
  }
}





// WEBPACK FOOTER //
// ./src/decorators/withAppStore.js